module.exports = __webpack_public_path__ + "b2b14ae9f667211c2c788d79771172d8.png";